import React, { useEffect, useRef } from "react";
import "./css/chats.css";
import UserChats from "./UserChats";
import BotChats from "./BotChats";

function Chats({ search, output }) {
  const chatEndRef = useRef(null);

  // Auto-scroll to the latest message
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [search, output]);

  const combinedChats = [];

  for (let i = 0; i < Math.max(search.length, output.length); i++) {
    if (search[i]) {
      combinedChats.push(
        <UserChats
          key={`user-${i}`}
          chatKey={`user-${i}`}
          userSearch={search[i]}
        />,
      );
    }

    if (output[i]) {
      combinedChats.push(
        <BotChats
          key={`bot-${i}`}
          chatKey={`user-${i}`}
          botOutput={output[i]}
          isWaiting={false}
        />,
      );
    } else if (search[i]) {
      // Only show the loading bot if there's a search but no output yet
      combinedChats.push(
        <BotChats
          key={`bot-loading-${i}`}
          chatKey={`user-${i}`}
          botOutput={"loading"}
          isWaiting={true}
        />,
      );
    }
  }

  return (
    <div className="chats-container">
      {combinedChats}
      <div ref={chatEndRef} />
    </div>
  );
}

export default Chats;
